import React, { useContext, useEffect, useState } from 'react';
import HeaderDashBoard from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/common/Footer';
import ScrollToTop from '../components/common/ScrollTop';
import { AuthContext } from '../context/AuthProvider';

function MainLayout({ children }) {
  const auth = useContext(AuthContext);
  const role = auth[0]?.userProfile?.type;

  return (
    <div className="App">
      <div className="header-margin" />
      <HeaderDashBoard />
      <div className="dashboard">
        <div className="dashboard__sidebar bg-white scroll-bar-1">
          <Sidebar role={role} />
        </div>

        <div className="dashboard__main">
          <div className="dashboard__content bg-light-2">{children}</div>
          <Footer />
        </div>
      </div>
      <ScrollToTop />
    </div>
  );
}

export default MainLayout;
